import bytes from 'bytes';
import { FileWithPreview } from './types';
import clsx from 'clsx';
import { KTSVG } from '../../../../_metronic/helpers';

interface Props {
  file: FileWithPreview;
  onRemove: () => void;
  className?: React.HTMLAttributes<HTMLDivElement>['className'];
}

export default function PdfPreview({ file, onRemove, className }: Props) {
  return (
    <div className={clsx('w-100 position-relative', className)}>
      <iframe
        src={file.preview}
        width='100%'
        height='100%'
        title='PDF Preview'
        style={{ border: '1px solid #ccc' }}
        loading='lazy' // Better performance
      />

      <div
        className='btn btn-icon btn-sm btn-dark bg-dark bg-opacity-75 position-absolute start-100 translate-middle fs-9'
        onClick={(e) => {
          e.stopPropagation();
          onRemove();
        }}
      >
        <KTSVG className='svg-icon-2' path='/media/icons/duotune/arrows/arr061.svg' />
      </div>
    </div>
  );
}
